import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import { rel } from '../../../../../utils/rel';

const LogoBox = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        render() {
            const {
                content: { url, image },
            } = this.props;

            return (
                <div className={styles.logo_dafeng}>
                    <a href={url} target="_blank" rel={rel}>
                        <img src={image} />
                    </a>
                </div>
            );
        }
    },
);

export default LogoBox;
